import * as React from "react"
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';
import { Button, Container, Row, Col, Form } from "react-bootstrap"
// import deskbanner from "../../../images/offplan/desk-banner.png";
import "./FormBlock.scss"

import GetStarted from "../../forms/get-started"
import Newsletter from "../../forms/newsletter" 
// markup
const FormBlock = (props) => {
    return (
        <React.Fragment>
            <section className={`form-section components--Home--FormBlock--FormBlock ${props.count == 1 ? 'form-main-one' : ''}`}>
                <Container>
                    <Row className="main-row">
                        <Col lg="12">
                            <div className="register-interest-form-block">
                                <div className="valuation-block">
                                    {props.Content &&
                                        <ScrollAnimation animateIn="fadeInUp">
                                            {parse(props.Content)}
                                        </ScrollAnimation>
                                    }
                                </div>
                                <div className="register-interest-form">
                                    <ScrollAnimation animateIn="fadeInUp">
                                        {props.Select_Form?.Select == 'Newsletter_Subscribe' ? <Newsletter /> : <GetStarted />}
                                    </ScrollAnimation>

                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    )
}

export default FormBlock
